import { render, staticRenderFns } from "./MaterialDialog.vue?vue&type=template&id=6cf92eff&scoped=true&"
import script from "./MaterialDialog.vue?vue&type=script&lang=js&"
export * from "./MaterialDialog.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDialog.vue?vue&type=style&index=0&id=6cf92eff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf92eff",
  null
  
)

export default component.exports